window.onload = function () {
    // fixedBanner();
};


function fixedBanner() {

    var banner = $('.widget-el');

    if (!banner.length) {
        return false;
    }
    var maxBottom = $('footer').offset().top - $(window).height();
    var offsetTop = $('.page').offset().top;
    $(window).bind('scroll', function () {
        var windowHeight = $(window).height();
        var that = $(this);

        currTop = that.scrollTop();


        if (currTop >= offsetTop && currTop < maxBottom) {
            banner.addClass('fixed-banner');
        } else {
            banner.removeClass('fixed-banner');
        }
    });
};


'use strict';

Array.prototype.find = Array.prototype.find || function(callback) {
    if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
    } else if (typeof callback !== 'function') {
        throw new TypeError('callback must be a function');
    }
    var list = Object(this);
    // Makes sures is always has an positive integer as length.
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    for (var i = 0; i < length; i++) {
        var element = list[i];
        if ( callback.call(thisArg, element, i, list) ) {
            return element;
        }
    }
};